module.exports = __webpack_public_path__ + "img/002.c7839810.jpg";